import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function RsiTileChartHelp() {
    return (
        <IconTooltip>
            <div>
                Relative Strength Index (“RSI”) measures the velocity and
                magnitude of price movements. <br /> <br />
                It is used to assess momentum - the rate of the rise or fall in
                a stock’s price - by computing the ratio of higher closes to
                lower closes over time periods. Symbols with stronger positive
                changes have a higher RSI than those more strongly negative. RSI
                readings &gt;70 approach an “overbought” ratio, and RSI readings
                &lt; 30 are in a direction to “oversold”. Ratios between 30 and
                70 are closer to neutral; 50 is a sign of no discernible trend.{' '}
                <br /> <br />
                The RSI Capsule can be configured by selecting a symbol from
                your portfolio or adding it into settings. Time period and
                lookback values may also be configured in the settings.
            </div>
        </IconTooltip>
    );
}
